<template>
  <div id="center">
	<span class="fs-xl text mx-2 pl-3" style="margin-top: 5px; margin-left: 10px; margin-top: 10px; padding-bottom: 0;">
		<icon name="align-left" class="text-icon" style="margin-right: 5px; float: left;"></icon>
		纳入管理人数
	</span>
    <div class="down">
      <div class="ranking bg-color-black">
        <dv-scroll-ranking-board class="dv-scr-rank-board mt-1" :config="ranking" />
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request';
export default {
  data() {
    return {
      ranking: {
      },
    }
  },
  components: {
    // CenterChart
  },
  created() {
	  request({
	  	url: this.$root.api + `/api/dbz/daping/dpdbz/` + 'scrqrs',
	  	method: 'get',
	  	}).then(res => {
	  	console.log('scrqrs--',res)
	  	var ranking = this.ranking
	  	ranking.data=res.data
          // ranking.data=[{"name":"三高","value":656852},{"name":"慢阻肺","value":100275},{"name":"糖尿病肾病","value":56024},{"name":"眩晕综合征","value":58965},{"name":"偏头痛","value":55662},{"name":"急性气管炎","value":58565},{"name":"慢性肺源性心脏病","value":52145}]
	  	ranking.carousel = 'single'
	  	ranking.unit = '人'
	  	console.log('ranking',ranking)
	  	this.ranking = {...ranking}
	  })
  }
}
</script>

<style lang="scss" scoped>
#center {
  display: flex;
  flex-direction: column;
  .up {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
    .item {
      border-radius: 6px;
      padding-top: 8px;
      margin-top: 8px;
      width: 25%;
      height: 70px;
      .dv-dig-flop {
        width: 150px;
        height: 30px;
      }
    }
  }
  .down {
    padding: 6px 4px;
    padding-bottom: 0;
    width: 100%;
    display: flex;
    height: auto;
	overflow: hidden;
    justify-content: space-between;
    .bg-color-black {
      border-radius: 5px;
    }
    .ranking {
      padding: 10px;
      width: 100%;
      .dv-scr-rank-board {
        height: 340px;
      }
    }
    .percent {
      width: 40%;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 50%;
        height: 120px;
        span {
          margin-top: 8px;
          font-size: 14px;
          display: flex;
          justify-content: center;
        }
      }
      .water {
        width: 100%;
        .dv-wa-le-po {
          height: 120px;
        }
      }
    }
  }
}
</style>
